import api from '@/js/services/axios'

export default {
  getMe () {
    return new Promise((resolve, reject) => {
      api.get('private/v1/users/me')
        .then(response => {
          var data = response.data
          resolve(this._processUserResponse(data))
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  
  /**
   * Get user's accounts from API (same shape as login: organization_id, organization_name, organization_identifier, organization_logo_url, roles).
   * Used by reloadAccount to refresh account list after e.g. creating a new organization.
   */
  getAccounts () {
    return api.get('private/v1/users/me/accounts').then(response => response.data || [])
  },

  /**
   * Create a new organization for the current user (e.g. from pricing plan).
   * Call user/reloadAccounts after this to refresh the account list.
   * @param {Object} payload - { organization_type: 'individual'|'organization', name: string, payment_plan?: string, approve_terms?: boolean }
   * @returns {Promise<{ id, name, identifier, ... }>} - the created organization DTO
   */
  createOrganization (payload) {
    return api.post('private/v1/users/me/organizations', {
      organization_type: payload.organization_type,
      name: payload.name,
      payment_plan: payload.payment_plan || undefined,
      approve_terms: payload.approve_terms === true
    }).then(response => response.data)
  },

  _processUserResponse(userData) {
    userData.emailVerified = userData.email_verified
    userData.preferredLanguage = userData.preferred_language
    
    if (userData.notification_settings && typeof userData.notification_settings === 'string'){
      try {
        let notificationSettings = JSON.parse(userData.notification_settings);
        userData.notification_settings = notificationSettings;
        
      } catch (error) {
        throw new Error('Failed to parse notification settings JSON:', error);
      }
    }

    return userData;
  }
}
